// extracted by mini-css-extract-plugin
module.exports = {"root":"PromptsEditor_root__1pmKB","prompts":"PromptsEditor_prompts__3kum-","markerBar":"PromptsEditor_markerBar__QU2So"};